import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import PropTypes from "prop-types";
import APPCONFIG from "constants/Config";
import ObjectOverride from "components/ObjectOverride";
import {confirmAlert} from "react-confirm-alert";
import API from "@beardeddevops/react.api";

/**
 *  @property {Transaction_Upload_Object} state
 *  @property {object} model
 *  @property {Transaction_Upload_Properties} model.properties
 *  @property {Transaction_Upload_Is} model.is
 *  @property {Transaction_Upload_Has} model.has
 */
export default class TransactionUpload extends ObjectOverride {

	constructor(props) {
		super(props, Types.Transaction_Upload._name);
		this.state.disabledSubmitButton = false;
		this.state.isModalOpen = true;
	}

	componentDidMount(){
		if(typeof this.props.handleDisableButton === 'function'){
			this.props.handleDisableButton(true);
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if(prevState.document_name !== this.state.document_name && this.state.document_name){
			if(typeof this.props.handleDisableButton === 'function'){
				this.props.handleDisableButton(false);
			}
		}
	}

	// noinspection JSUnusedGlobalSymbols
	// loadSelf = async () => {
	// 	let data = this.props.identification;
	// 	if (this._ismounted && data) {
	// 		this.model.properties.forEach((item, key) => {
	// 			if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
	// 				this.setState({[key]: data[key]});
	// 			}
	// 		});
	// 		this.model.has.forEach((item, key) => {
	// 			if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
	// 				this.setState({[key]: data[key]});
	// 			}
	// 		});
	// 		this.model.is.forEach((item, key) => {
	// 			if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
	// 				this.setState({[key]: data[key]});
	// 			}
	// 		});
	// 		await this.setState({
	// 			"loading": false,
	// 			"loaded": true
	// 		});
	// 		// noinspection JSPotentiallyInvalidUsageOfClassThis
	// 		this.loadSelfAfter(data);
	// 	}
	//
	// 	this.loadSelfAfterAlways();
	// };

	handleSubmit = async () => {
		if (!this.state.document_name) {
			return;
		}

		let currCollection = this.props.history.location.pathname.split('/')[2].split('-');
		this.state.collection_binary_id = currCollection[0];
		this.state.collection = currCollection[1];
		this.state.binary_id = currCollection[0];

		this.state.document_type = this.state.document_name.substring(this.state.document_name.lastIndexOf("."));
		await super.handleSubmit();

		this.props.history.push(`${this.props.history.location.pathname}#upload`)
		this.state.account_password = null;
		this.state.account_email = null;
		this.props.reloadTable();

		if (typeof this.props.reloadPage === 'function') {
			this.props.reloadPage();
		}

		if (typeof this.props.reportClose === 'function') {
			this.props.reportClose();
		}
	}

	form = () => {
		/** @type {Transaction_Upload_Properties} properties */
		let properties = this.model.properties;
		/** @type {Transaction_Upload_Object} object */
		let object = this.state;
		let {loading} = this.state;
		return (
			<div>
				<fieldset>
					<div className={"form-group"}>
						<p>
							These are the formats that we accept: .doc, .docx, .pdf, .rtf, .txt, .xml, .csv, .xls, .xlsm, .xlsx, .gif, .jpeg, .jpg,
							.png, .heif, .hevc, .odt, .ods, .odp, .odg, .raw, .mov, .m4v, .mp4, .mp3.
						</p>
						<h4>Current Uploaded File: {object.document_name ? object.document_name : 'Nothing Uploaded Yet'}</h4>
						<div>
						<Framework.Elements.DropZone
							button={true}
							accept={[".doc", ".docx", ".pdf", ".rtf", ".txt", ".xml", ".csv", ".xls", ".xlsm", ".xlsx", ".gif", ".jpeg", ".jpg", ".png", ".heif", ".hevc", ".odt", ".ods", ".odp", ".odg", ".raw", ".mov", ".m4v", ".mp4", ".mp3"]}
							property={properties.document_name}
							value={object.document_name}
							error={object.document_name_error}
							update={this.handleFileChange}
							label={'Drag \'n\' drop file here, or click to select file'}
							maxSize={4e+8}
						/>
						</div><br/><br/>
						<div>
						<Framework.Elements.TextField
							label={"Description"}
							property={properties.description}
							value={object.description}
							error={object.description_error}
							update={this.handleTextFieldPropertyUpdate}
							multiline={2}
						/>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>

			</div>
		)
	};

}
